import auth from '@/auth';
import router from '@/router';
import axios from 'axios';

const baseUrl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + process.env.VUE_APP_API_BASE;

export default {
  post(url, data) {
    return axios.post(baseUrl + url, data)
      .then(({data}) => {
        return data;
      });
  },
  get(url) {
    return axios.get(baseUrl + url)
      .then(({data}) => {
        return data;
      });
  },
  authGet(url) {
    return axios.get(baseUrl + url, { headers: {'Authorization' : auth.getToken()}})
      .then(({data}) => {
        return data;
      })
      .catch(({response}) => {
        if (response.status) {
          router.push({name: 'logout'});
        }
      });
  },
  authPost(url, data) {
    return axios.post(baseUrl + url, data, { headers: {'Authorization' : auth.getToken()}})
      .then(({data}) => {
        return data;
      });
  }
}
